import React, {Suspense} from 'react'
import PageLayout from '@view/layout/pageLayout/PageLayout'
import SpinnerCustom from '@ui/spinner/SpinnerCustom'
import VideoStreamsByAccount from '@containers/video/videoStreams/videoStreamsByAccount/VideoStreamsByAccount'

const VideoStreamsListPage = () => {
	return (
		<PageLayout>
			<Suspense
				fallback={<SpinnerCustom/>}
			>
				<VideoStreamsByAccount/>
			</Suspense>
		</PageLayout>
	)
}

export default VideoStreamsListPage